import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { callAPI } from "../../../axios";
import { setWorkspace } from "../../../store/actions/WorkspaceActions";
import { buildWorkspaceOptions,  isValidProject } from "../../../constants/workspaceConfig";
import "./UserBox.scss";

const WorkspaceSwitcher = ({ inline = false }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const workspace = useSelector((s) => s.workspaceReducer?.workspace || "STB");
  const userProjects = useSelector((s) => s.authReducer?.userProjects);

  const WORKSPACE_OPTIONS = useMemo(() => {
    const projects =
      userProjects && userProjects.length > 0
        ? userProjects
        : JSON.parse(localStorage.getItem("userProjects") || "[]");
    return buildWorkspaceOptions(projects);
  }, [userProjects]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const currentWorkspace =
    WORKSPACE_OPTIONS.find((option) => option.value === workspace) ||
    WORKSPACE_OPTIONS[0];

  const toggleDropdown = () => setDropdownOpen((open) => !open);

  const switchTo = (target) => {
    if (target === workspace) {
      setDropdownOpen(false);
      return;
    }

    const selected = WORKSPACE_OPTIONS.find((option) => option.value === target);
    if (!selected) return;

    dispatch(setWorkspace(target));
    if (isValidProject(target)) {
      callAPI(`/user/active-project?projectId=${selected.projectId}`, "PUT").catch(
        () => {}
      );
    }
    history.push(selected.route);
    setDropdownOpen(false);
  };

  return (
    <div className={inline ? "workspace-switcher" : "header-btn-lg pr-0 workspace-switcher"}>
      <div className="ws-switcher-wrapper">
        <div
          className="ws-switcher-header"
          onClick={toggleDropdown}
          role="button"
          tabIndex={0}
          onKeyDown={(e) =>
            (e.key === "Enter" || e.key === " ") && toggleDropdown()
          }
        >
          <span className="ws-switcher-label">Switch Workspace</span>
          {dropdownOpen ? (
            <ExpandLessIcon className="ws-switcher-caret" />
          ) : (
            <ExpandMoreIcon className="ws-switcher-caret" />
          )}
        </div>
        {dropdownOpen && (
          <div className="ws-switcher-dropdown">
            <ul>
              {WORKSPACE_OPTIONS.map((option) => (
                <li
                  key={option.value}
                  className={option.value === workspace ? "workspace-active" : ""}
                  onClick={() => switchTo(option.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      switchTo(option.value);
                    }
                  }}
                  role="option"
                  aria-selected={option.value === workspace}
                  tabIndex={0}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkspaceSwitcher;
